import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/user/user.service';
import { GopherService } from '../gopher.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { resolve } from 'url';

@Component({
  selector: 'app-attack',
  templateUrl: './attack.component.html',
  styleUrls: ['./attack.component.less']
})
export class AttackComponent implements OnInit {

  constructor(private _userService: UserService, private gopherService: GopherService, private toastr: ToastrService,
              private route: ActivatedRoute, private router: Router) { }

  myProjects;
  projectId;
  clientId;
  clientsList;
  attackClients;
  showAdd = false;
  config = {
    name: null,
    userName: null,
    hostAddress: null,
    server_type: null,
    clientId: null,
    project: null,
  };
  attack = {
    type: null,
    args : {
      duration: null,
      core: null,
      useSwap: true,
      percentage: null,
      delay: null
    },
    gopherClient: {
      id: null
    },
    reboot: false
  };
  user;

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (!this.user.gopherAdmin) {
      this.router.navigate(['home']);
    }
    this.projectId = parseInt(this.route.snapshot.queryParamMap.get('project'));
    this.clientId = parseInt(this.route.snapshot.queryParamMap.get('client'));
    this.config.server_type = 'Web server';

    this.getMyProjects().then(projects => {
      if (projects) {
        projects.forEach(element => {
          if (this.projectId === element.id) {
            this.config.project = element;
          }
        });
        if (this.config.project && this.config.project !== undefined) {
          this.getClientsById(this.config.project).then(data => {
            this.attackClients = data;
            data.forEach(element => {
              if (element.id === this.clientId) {
                this.attack.gopherClient = element;
              }
            });
          });
        }
      }
    });
  }

  getMyProjects(): Promise<any> {
    return new Promise(resolve => {
      this._userService.getMyProjectList().pipe().subscribe(data => {
        if (data.code === 200) {
          resolve(data.response);
          this.myProjects = data.response;
        }
      });
    });
  }

  getClientsById(confProject): Promise<any> {
    return new Promise(resolve => {
      this.gopherService.getClientsById(confProject.id).pipe().subscribe(data => {
        if (data.code === 200) {
          resolve(data.response);
        }
      })
    })
  }

  saveAttack(attack) {
    if (attack.type !== 'MEMORY') {
      delete attack.args.useSwap;
    }

    if (!attack) { return; }
    let errorCount = 0;

    if (!attack.type) {
      this.toastr.error('Select an attack type');
      errorCount++;
    }

    const mandatoryArgMissing = this.checkAttackArgs(attack);
    if (mandatoryArgMissing) {
      this.toastr.error('Please enter the args values !!!');
      errorCount++;
    }

    if (attack.type && attack.args) {
      Object.keys(attack.args).forEach((item) => {
      });
    }

    if (errorCount > 0) { return; }

    delete attack.reboot;
    attack.attackedBy = this.user;

    this.gopherService.saveAttack(attack).pipe().subscribe(data => {
      if (data.code === 200) {
        this.toastr.success(data.message);
        this.router.navigate(['../'+data.response],{ relativeTo: this.route});
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  checkAttackArgs(attack) {
    let mandatoryArgsMissing = false;
    switch (attack.type) {
      case 'CPU':
        if (!attack.args.duration || !attack.args.core) {
          mandatoryArgsMissing = true;
        }
        break;
      case 'DISK':
      case 'MEMORY':
        if (!attack.args.duration || !attack.args.percentage) {
          mandatoryArgsMissing = true;
        }
        break;
      case 'SHUTDOWN':
        if (!attack.args.delay) {
          mandatoryArgsMissing = true;
        }
        break;
    }
    return mandatoryArgsMissing;
  }
}
